function FourSixtySlider() {
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = '//foursixty.com/media/scripts/fs.slider.v2.5.js';
    script.setAttribute('data-feed-id', 'tlf-apparel_3');
    script.setAttribute('data-theme', 'slider_v2_5');
    script.setAttribute('data-connector-filter', '52840,53280');
    script.setAttribute('data-cell-size', '25%');
    script.setAttribute('data-has-posts-selector', '#foursixty-hideable-container');
    script.setAttribute('data-for-url', 'true');
    document.getElementById('foursixty-hideable-container').appendChild(script);
    return () => {
      document.getElementById('foursixty-hideable-container').removeChild(script);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "foursixty-hideable-container",
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "largeThinText"
  }, "seen on instagram")));
}
;
